import * as React from 'react'

import { Label } from '../typography'
import { Container, StyledTextareaAutosize, ValidationHint } from './TextArea.styles'

interface IProps {
  label?: string
  placeholder: string
  validationHint?: string
  disabled: boolean
  invalid: boolean
  required: boolean
  minRows: number
  value: string
  onChange: (value: string) => void
}

export default class TextArea extends React.Component<IProps> {
  public static defaultProps = {
    disabled: false,
    invalid: false,
    required: false,
    minRows: 2,
  }

  public render() {
    const { disabled, label, placeholder, required, minRows, validationHint, value } = this.props
    const invalid = this.props.invalid || !!validationHint

    return (
      <Container>
        {label && <Label>{label}</Label>}
        <StyledTextareaAutosize
          minRows={minRows}
          placeholder={placeholder}
          value={value}
          aria-invalid={invalid}
          disabled={disabled}
          required={required}
          onChange={this.handleChange}
        />
        {validationHint && <ValidationHint>{validationHint}</ValidationHint>}
      </Container>
    )
  }

  private handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.props.onChange(event.target.value)
  }
}
